import { useDocumentTitle } from "@/lib/use-document-title";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";
import { AccessBranding } from "@/components/AccessBranding";
import { BackLink } from "@/components/BackLink";
import { translateAuthError } from "@/lib/auth-errors";

export default function ResetPassword() {
  useDocumentTitle("Nytt lösenord — Lagamobilen Access");
  const navigate = useNavigate();
  const [ready, setReady] = useState(false);
  const [pwd, setPwd] = useState("");
  const [pwd2, setPwd2] = useState("");
  const [err, setErr] = useState("");
  const [ok, setOk] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    // Supabase places the recovery session in the URL hash; the client picks it up automatically.
    const { data: sub } = supabase.auth.onAuthStateChange((event) => {
      if (event === "PASSWORD_RECOVERY" || event === "SIGNED_IN") setReady(true);
    });
    supabase.auth.getSession().then(({ data }) => { if (data.session) setReady(true); });
    return () => sub.subscription.unsubscribe();
  }, []);

  async function submit(e: React.FormEvent) {
    e.preventDefault();
    setErr("");
    if (pwd.length < 8) return setErr("Lösenordet måste vara minst 8 tecken");
    if (pwd !== pwd2) return setErr("Lösenorden matchar inte");
    setBusy(true);
    const { error } = await supabase.auth.updateUser({ password: pwd });
    setBusy(false);
    if (error) return setErr(translateAuthError(error.message));
    setOk(true);
    setTimeout(() => navigate("/access/login"), 1500);
  }

  return (
    <div className="min-h-screen bg-[var(--color-ink)] flex items-center justify-center px-6 py-10">
      <div className="w-full max-w-md">
        <div className="mb-4"><BackLink fallback="/access/login" /></div>
        <div className="text-center mb-8"><AccessBranding /></div>
        <div className="card-soft p-8">
          {ok ? (
            <p className="text-center text-foreground">Lösenord uppdaterat! Skickar dig till inloggning…</p>
          ) : !ready ? (
            <p className="text-center text-muted-foreground">Verifierar återställningslänk…</p>
          ) : (
            <form onSubmit={submit}>
              <h1 className="!text-2xl text-center mb-2">Välj nytt lösenord</h1>
              <p className="text-center text-muted-foreground text-sm mb-6">Minst 8 tecken.</p>
              <label className="label-field">Nytt lösenord</label>
              <input type="password" className="input-field" value={pwd} onChange={e => setPwd(e.target.value)} />
              <label className="label-field mt-3">Bekräfta lösenord</label>
              <input type="password" className="input-field" value={pwd2} onChange={e => setPwd2(e.target.value)} />
              {err && <p className="text-destructive text-xs mt-2">{err}</p>}
              <button type="submit" disabled={busy} className="btn-pill w-full mt-6">{busy ? "Sparar…" : "Spara lösenord"}</button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
